import { gql } from '@apollo/client';

export const CREATE_ADDRESS_RESIDENTIAL_AREA = gql`
  mutation CreateAddressResidentialArea($input: CreateAddressResidentialAreaGraphqlInput!) {
    createAddressResidentialArea(input: $input) {
      id
      residentialAddress
      standardAddress
      residentialName
      cityName
      stateAbbreviation
      zipcode
      images {
        id
        residentialAreaId
        imageS3Key
        stopNumber
        imageDisplayUrl
      }
    }
  }
`;

export const UPDATE_ADDRESS_RESIDENTIAL_AREA = gql`
  mutation UpdateAddressResidentialArea($id: Long!, $input: UpdateAddressResidentialAreaGraphqlInput!) {
    updateAddressResidentialArea(id: $id, input: $input) {
      id
      residentialAddress
      standardAddress
      residentialName
      cityName
      stateAbbreviation
      zipcode
      images {
        id
        residentialAreaId
        imageS3Key
        stopNumber
        imageDisplayUrl
      }
    }
  }
`;

/** 更新小区时传入的图片项（id 可选：有 id 则更新，无 id 则新建） */
export interface UpdateAddressResidentialAreaImageItemInput {
  id?: number;
  imageS3Key: string;
  stopNumber: number;
}

export const REJECT_ADDRESS_RESIDENTIAL_AREA_REPORT = gql`
  mutation RejectAddressResidentialAreaReport($id: Long!) {
    rejectAddressResidentialAreaReport(id: $id)
  }
`;

export const DELETE_ADDRESS_RESIDENTIAL_AREA = gql`
  mutation DeleteAddressResidentialArea($id: Long!) {
    deleteAddressResidentialArea(id: $id)
  }
`;

